import { Divider, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { ProductItem, ProductTotal } from '../../components';
import { useCheckoutState } from '../../store';

export const DataMyProducts = () => {
  const { t } = useTranslation('checkout/data');

  const { selectedPlans } = useCheckoutState();

  const total = selectedPlans.reduce(
    (acc, plan) => acc + plan.amountPrice * plan.quantity,
    0,
  );

  return (
    <Flex
      flexDir="column"
      bg="brand.50"
      px={{ base: 6, lg: 10 }}
      py={{ base: 6, lg: 14 }}
      borderRadius={16}
      w="full"
      maxW={420}
      gap={5}
      minH="full"
    >
      <Text
        color="brand.500"
        fontSize="2xl"
        fontWeight="semibold"
        textAlign={{ base: 'center', lg: 'left' }}
      >
        {t('myProducts')}
      </Text>

      <Flex flexDir="column" bg="white" gap={5} p={5} borderRadius={12}>
        {selectedPlans.map((plan, index) => (
          <ProductItem key={plan.planId + index} product={plan} />
        ))}

        {selectedPlans.length > 0 && <Divider borderWidth={0.5} />}

        <ProductTotal total={total} />
      </Flex>
    </Flex>
  );
};
